import { parseViewParams, getAdminSecret } from './utils';
import { Hero } from './components/Hero';
import { CardViewer } from './components/CardViewer';
import { SubmitForm } from './components/SubmitForm';
import { ActivatePage } from './components/ActivatePage';
import { DeletePage } from './components/DeletePage';
import { AdminView } from './components/AdminView';
import './index.css';

export function App() {
  const { view, activate, delete: deleteCode } = parseViewParams();
  const adminSecret = getAdminSecret();

  if (adminSecret) return <AdminView secret={adminSecret} />;
  if (activate) return <ActivatePage code={activate} />;
  if (deleteCode) return <DeletePage code={deleteCode} />;

  return (
    <div className="min-h-screen bg-[#0d0d1a] text-slate-200 lg:h-screen lg:overflow-hidden">
      <div className="lg:grid lg:h-screen lg:grid-cols-[minmax(360px,48vw)_minmax(0,1fr)]">
        <Hero />
        <main className="lg:h-screen lg:overflow-y-auto">
          <CardViewer />
        </main>
      </div>
      {view === 'submit' ? (
        <SubmitForm onClose={() => { window.location.href = '/'; }} />
      ) : (
        <a
          href="/?view=submit"
          className="fixed right-4 top-4 z-40 rounded-lg bg-violet-600 px-5 py-3 font-medium text-white shadow-lg shadow-black/25 transition-colors hover:bg-violet-700 sm:right-6 sm:top-6"
        >
          Add message
        </a>
      )}
    </div>
  );
}

export default App;
